// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__KoScg","filled":"IconReviewStar_filled__3yVLM"};